import { type BaseApiErrorResponse, HttpStatus } from '../types/api.types';
import BaseApiResponseError from './BaseApiResponseError';

export type UnprocessableEntityArgs<TErrors> = Omit<
  BaseApiErrorResponse<TErrors>,
  'status'
>;
export default class UnprocessableEntity<
  TErrors,
> extends BaseApiResponseError<TErrors> {
  constructor({ code, errors, message }: UnprocessableEntityArgs<TErrors>) {
    // A coded business refusal has no field errors at all; `null` is how every
    // other error class says so, and `undefined` here was the odd one out.
    super({
      code,
      errors: errors ?? null,
      message,
      status: HttpStatus.UnprocessableEntity,
    });
  }
}
